import React from "react";
import "./CentralLayout.css";

export default function CentralLayout({ children }) {
  return <div className="central-layout">{children}</div>;
}
